import { Addressable } from './api-common.js';
import { BASE_API_URL } from '../envs.js';
import { replaceAll } from '../helpers/string.js';
import { apiCodeToLandCode } from '../layers/layerHelpers.js';
export class GoodToKnowBase extends Addressable {
    constructor(data) {
        super(data);
        Object.assign(this, data);
    }
}
export class Arrival extends GoodToKnowBase {
    constructor(data) {
        super(data);
        Object.assign(this, data);
    }
}
export class Direction extends GoodToKnowBase {
    constructor(data) {
        super(data);
        Object.assign(this, data);
    }
}
export class Detour extends GoodToKnowBase {
    constructor(data) {
        let detour;
        if (typeof data.get === 'function') {
            data = data;
            const land = data.get('land');
            detour = {
                id: data.getId(),
                refid: data.getId(),
                title: data.get('title'),
                land: land,
                lands: parseLands(land),
                text: data.get('abstract'),
                reason: data.get('reason'),
                state: data.get('state_validate'),
                urlLink: data.get('url1_link'),
                urlText: data.get('url1_text'),
                dataSource: data.get('content_provider'),
                file: data.get('file'),
                duration: data.get('duration'),
                start: data.get('date_start'),
                end: data.get('date_end'),
                photoUrls: data.get('photo_img_urls'),
                symbolStartEnd: data.get('symbol_start_end'),
                symbolIntermediate: data.get('symbol_intermediate'),
                type: data.get('type'),
                typeCode: data.get('type_code'),
            };
        }
        else {
            data = data;
            data.lands = parseLands(data.land);
            if (data.hikingNetwork === true && !data.lands.includes('hike')) {
                data.lands.push('hike');
            }
            detour = data;
        }
        super(detour);
        Object.assign(this, detour);
        if (this.start)
            this.start = replaceAll(new Date(this.start).toLocaleDateString('en-GB'), '/', '.');
        if (this.end)
            this.end = replaceAll(new Date(this.end).toLocaleDateString('en-GB'), '/', '.');
    }
}
function parseLands(land) {
    const landLayers = land ? land.split(',') : [];
    return landLayers.map((l) => apiCodeToLandCode[l]);
}
export async function fetchArrivals(ids, lang) {
    const response = await fetch(`${BASE_API_URL}/api/4/goodtoknow/arrivals/${ids.join(',')}?lang=${lang}`);
    const arrivals = await response.json();
    return arrivals.map((a) => new Arrival(a));
}
export async function fetchDirections(ids, lang) {
    const response = await fetch(`${BASE_API_URL}/api/4/goodtoknow/directions/${ids.join(',')}?lang=${lang}`);
    const directions = await response.json();
    return directions.map((d) => new Direction(d));
}
export async function fetchDetours(ids, lang) {
    const response = await fetch(`${BASE_API_URL}/api/4/goodtoknow/detours/${ids.join(',')}?lang=${lang}`);
    const detours = await response.json();
    return detours.map((d) => new Detour(d));
}
//# sourceMappingURL=api-goodtoknow.js.map